import { apiJSON } from '../config/api';

/**
 * Liste des livres — même contrat que l’ancien loadBooks (AppContext).
 * @returns {Promise<Array>}
 */
export async function fetchBooks() {
  const response = await apiJSON('books');
  const books = response.books || response.items || response || [];
  return Array.isArray(books) ? books : [];
}
